<template>
  <div>
    <messagePopup
      :dialog-title="titleText"
      :append-to-body="true"
      :dialog-type="''"
      :popup-top="'10vh'"
      :show-close="true"
      :center-dialog-visible="quotationNoticeVisible"
      :popup-width="'800px'"
      :show-btn="false"
      @resetPopupData="resetPopupData"
    >
      <div class="box">
        <div class="content_box">
          <div class="box_li">
            <div class="box_title" @click="handleProtocol">
              <span>{{ tipTitle }}</span>
              <i v-show="showContentFlag" class="el-icon-arrow-up"></i>
              <i v-show="!showContentFlag" class="el-icon-arrow-down"></i>
            </div>
            <div v-if="protocolType === 'supplier'" class="rate-num">该业务询比价服务费率为{{ rateNum }}‰</div>
          </div>
          <div v-if="showContentFlag" class="box_li">
            <div>
              <div id="contentHeight" class="box_content">
                <div>
                  <div class="box_text info_box margin-b20">
                    <div style="width: 48%; display: flex; flex-direction: column">
                      <p>甲方：易派客电子商务有限公司</p>
                      <p>住所：北京市朝阳区朝阳门北大街22号1幢6层628室</p>
                      <!-- <p>法定代表人：沈中祥</p> -->
                    </div>
                    <div style="width: 48%; display: flex; flex-direction: column">
                      <p>乙方：{{ companyName }}</p>
                      <p>住所：{{ companyAdress }}</p>
                      <!-- <p>法定代表人：{{ legalPerson }}</p> -->
                    </div>
                  </div>

                  <div class="box_text" v-html="tipContent"></div>

                  <div class="box_text info_box margin-b20">
                    <div style="width: 48%; display: flex; flex-direction: column">
                      <p>甲方：易派客电子商务有限公司</p>
                      <!-- <p>该协议一经乙方确认将自动生效。</p> -->
                    </div>
                    <div style="width: 48%; display: flex; flex-direction: column">
                      <p>乙方：{{ companyName }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isView">
          <div class="box_text" style="margin: 20px 0; display: flex">
            <el-checkbox :value="agreeCheck" @change="handleChangeCheck"></el-checkbox>
            <span style="margin-left: 10px">已阅读并同意《询比价服务协议》</span>
          </div>
        </div>
        <div class="flex-c" :style="{ 'margin-top': !isView ? 0 : '20px' }">
          <eui-btn type="weak" @click="closeDialog">
            {{ !isView ? '取消' : '关闭' }}
          </eui-btn>
          <eui-btn
            v-if="!isView"
            v-debounce="handleSubmit"
            type="primary"
            :disabled="!agreeCheck"
            style="margin-left: 20px"
          >
            确定
          </eui-btn>
        </div>
      </div>
    </messagePopup>
  </div>
</template>

<script>
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import messagePopup from '../common/e-messagePopup.vue';
import api from '../../api/user/index.js';
import { tipContentSupplierData, tipContentPurchaserData } from './tipContentNew';

export default {
  components: {
    EuiBtn,
    messagePopup,
  },
  props: {
    quotationNoticeVisible: Boolean,
    protocolType: String,
    rateNum: Number,
    isView: Boolean,
  },
  data() {
    return {
      tipTitle: '询比价服务协议（供应商）',
      isBottom: false,
      tipContent: '',
      showContentFlag: true,
      agreeCheck: false,
      companyName: '',
      titleText: '询比价须知：',
      boxElement: '',
      companyAdress: '',
      companyId: '',
      legalPerson: '',
    };
  },
  mounted() {
    const date = new Date();
    this.dateTime = date.toLocaleDateString().replace(/\//g, '-');

    this.userInfo = JSON.parse(localStorage.getItem('USERINFO'));
    if (this.userInfo) {
      this.companyName = this.userInfo.companyName;
      this.companyId = this.userInfo.companyId;
    }

    this.$nextTick(() => {
      if (this.protocolType === 'supplier') {
        this.tipTitle = '询比价服务协议（供应商）';
        console.log(this.rateNum, 'this.rateNum');
        this.tipContent = tipContentSupplierData(this.rateNum);
      } else if (this.protocolType === 'purchaser') {
        this.tipTitle = '询比价服务协议（采购商）';

        this.tipContent = tipContentPurchaserData(this.rateNum);
      }
      this.getCompanyDetail(this.companyId);

      // this.initHeight();
    });
  },
  methods: {
    async getCompanyDetail(companyId) {
      const res = await api.queryCompanyLegalRepresentativeAndRegCity({
        companyId,
      });
      if (res.code === '200') {
        this.companyAdress = res.data.regCity;
        this.legalPerson = res.data.legalRepresentative;
      }
    },
    // 协议
    handleProtocol() {
      this.showContentFlag = !this.showContentFlag;
    },
    // 勾选
    handleChangeCheck() {
      this.agreeCheck = !this.agreeCheck;
    },
    handleSubmit() {
      this.$emit('handleConfirm');
    },
    resetPopupData() {
      this.$emit('closeDialog');
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    dealHeight() {
      const clientHeight = this.boxElement.scrollTop;
      console.log(clientHeight, 'clientHeight');
      if (this.protocolType === 'supplier') {
        if (clientHeight > 2400) {
          this.isBottom = true;
        }
      } else if (clientHeight > 2100) {
        this.isBottom = true;
      }
    },
    initHeight() {
      this.boxElement = document.getElementById('contentHeight');
      this.boxElement.addEventListener('scroll', this.dealHeight, true);
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  /*padding: 0 30px 20px;*/
  .content_box {
    width: 100%;
    min-height: 108px;
    .box_li {
      width: 100%;
      min-height: 53px;
      border-bottom: 1px solid #d9d9d9;
      .box_title {
        font-weight: 700;
        box-sizing: border-box;
        padding: 0 20px;
        width: 100%;
        height: 53px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        font-size: 14px;
      }
      .rate-num {
        padding: 0 20px;
        margin-top: -10px;
        margin-bottom: 10px;
      }
    }
    .box_content {
      width: 100%;
      height: 340px;
      box-sizing: border-box;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: scroll;
      .box_text {
        font-size: 12px;
        line-height: 21px;
        color: #000;
        text-align: justify;
      }
      .info_box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
      }
    }
  }
  .submit_btn {
    margin: 20px auto 0;
    cursor: pointer;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2587ff;
    color: #fff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
::v-deep .el-input__inner {
  width: 300px;
  border-radius: 0;
  color: #333;
}
::v-deep .el-form-item__label {
  font-size: 14px;
  color: #333;
}
</style>
